// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownContainer_byMEZ {
  position: relative;
  min-width: 180px;
  .dropdownHeader_iVo0A {
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 5px;
    background-color: var(--f5-background);
    padding: 4px;
    padding: 4px 12px;
    height: 35px;
    box-sizing: border-box;

    svg {
      width: 20px;
      height: 20px;
      border-radius: 7px;
      -webkit-border-radius: 7px;
      -moz-border-radius: 7px;
      -ms-border-radius: 7px;
      -o-border-radius: 7px;
}
  }
  .disabledDropdownHeader_pRcXt {
    background-color: transparent;
    cursor: default;
  }
}

.dropdownList_y7PAa::-webkit-scrollbar {
  display: none; 
}
.dropdownList_y7PAa {
  position: absolute;
  max-height: 180px;
  overflow-y: scroll;
  background-color: var(--white-color);
  width: 100%;
  z-index: 2;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  box-shadow: 0px 4px 8px var(--_0000001a-shadow);
  scrollbar-width: none; 
  -ms-overflow-style: none;
  .dropdownItem_OR9D9 {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 3px;
    border-radius: 4px;
    box-sizing: border-box;
    gap: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 8px;
    transition: background-color 0.2s;
    -webkit-transition: background-color 0.2s;
    -moz-transition: background-color 0.2s;
    -ms-transition: background-color 0.2s;
    -o-transition: background-color 0.2s;
    &:hover {
      background-color: var(--f5-background);
    }
    svg {
      min-width: 20px;
      max-width: 20px;
      height: 20px;
      border-radius: 7px;
      -webkit-border-radius: 7px;
      -moz-border-radius: 7px;
      -ms-border-radius: 7px;
      -o-border-radius: 7px;
}
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/DropdownFlags/DropdownFlags.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;;IAEtB;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;AAC3B;EACE;EACA;IACE,6BAA6B;IAC7B,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,+CAA+C;EAC/C,qBAAqB;EACrB,wBAAwB;EACxB;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,iCAAiC;IACjC,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;IACpC;MACE,sCAAsC;IACxC;IACA;MACE,eAAe;MACf,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;AAC3B;EACE;AACF","sourcesContent":[".dropdownContainer {\n  position: relative;\n  min-width: 180px;\n  .dropdownHeader {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    gap: 5px;\n    background-color: var(--f5-background);\n    padding: 4px;\n    padding: 4px 12px;\n    height: 35px;\n    box-sizing: border-box;\n\n    svg {\n      width: 20px;\n      height: 20px;\n      border-radius: 7px;\n      -webkit-border-radius: 7px;\n      -moz-border-radius: 7px;\n      -ms-border-radius: 7px;\n      -o-border-radius: 7px;\n}\n  }\n  .disabledDropdownHeader {\n    background-color: transparent;\n    cursor: default;\n  }\n}\n\n.dropdownList::-webkit-scrollbar {\n  display: none; \n}\n.dropdownList {\n  position: absolute;\n  max-height: 180px;\n  overflow-y: scroll;\n  background-color: var(--white-color);\n  width: 100%;\n  z-index: 2;\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n  box-shadow: 0px 4px 8px var(--_0000001a-shadow);\n  scrollbar-width: none; \n  -ms-overflow-style: none;\n  .dropdownItem {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    padding: 3px;\n    border-radius: 4px;\n    box-sizing: border-box;\n    gap: 5px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding: 8px;\n    transition: background-color 0.2s;\n    -webkit-transition: background-color 0.2s;\n    -moz-transition: background-color 0.2s;\n    -ms-transition: background-color 0.2s;\n    -o-transition: background-color 0.2s;\n    &:hover {\n      background-color: var(--f5-background);\n    }\n    svg {\n      min-width: 20px;\n      max-width: 20px;\n      height: 20px;\n      border-radius: 7px;\n      -webkit-border-radius: 7px;\n      -moz-border-radius: 7px;\n      -ms-border-radius: 7px;\n      -o-border-radius: 7px;\n}\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContainer": `dropdownContainer_byMEZ`,
	"dropdownHeader": `dropdownHeader_iVo0A`,
	"disabledDropdownHeader": `disabledDropdownHeader_pRcXt`,
	"dropdownList": `dropdownList_y7PAa`,
	"dropdownItem": `dropdownItem_OR9D9`
};
export default ___CSS_LOADER_EXPORT___;
